import * as Sentry from "@sentry/react";
import { getWebEnv } from "../env.js";

let initialized = false;

export function initSentry() {
  if (initialized) return;

  const env = getWebEnv();
  if (!env.sentryDsn) {
    return;
  }

  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.appEnv,
    release: env.release,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    tracesSampleRate: env.appEnv === "production" ? 0.2 : 1.0,
    replaysSessionSampleRate: env.appEnv === "production" ? 0.05 : 0.2,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      event.tags = { ...event.tags, app_env: env.appEnv };
      return event;
    }
  });

  initialized = true;
}

export function syncSentryUser(session) {
  if (!initialized) return;
  if (!session) {
    Sentry.setUser(null);
    return;
  }
  Sentry.setUser({
    id: session.id,
    email: session.email,
    username: session.name,
    segment: session.roles?.[0]
  });
}

export function tagRequest(requestId) {
  if (!initialized || !requestId) return;
  Sentry.setTag("request_id", requestId);
}

export function captureApiError(error, context = {}) {
  if (!initialized) return;
  Sentry.withScope((scope) => {
    if (context.requestId) scope.setTag("request_id", context.requestId);
    scope.setExtra("apiContext", context);
    scope.setFingerprint(["api-error", context.path ?? "unknown"]);
    Sentry.captureException(error);
  });
}
